import { render, staticRenderFns } from "./TicketReclassifyDialog.vue?vue&type=template&id=69518414"
import script from "./TicketReclassifyDialog.js?vue&type=script&lang=js&external"
export * from "./TicketReclassifyDialog.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports